import { makeStyles } from '@material-ui/core';
import React from 'react';

const useStyles = makeStyles(() => ({
    root: {
        display: 'flex',
        flexDirection: 'column',
        marginTop: -12,
    },
    label: {
        whiteSpace: 'nowrap',
        overflow: 'visible',
        textOverflow: 'ellipsis',
        position: 'relative',
        display: 'inline-block',
        fontSize: '11px',
        color: 'hsla(0,0%,100%,.7)',
        marginBottom: '4px',
        verticalAlign: 'middle',
        fontFamily: "PT Sans, sans-serif",
        userSelect: 'none'
    },
    select: {
        position: 'relative',
        borderRadius: '4px',
        height: '32px',
        overflow: 'visible',
        boxShadow: '0 1px 0 0 hsl(0deg 0% 100% / 15%), inset 0 1px 0 0 rgb(0 0 0 / 15%)',
        border: 0,
        background: '#141b33',
        color: '#fff',
        outline: 'none',
        paddingLeft: 8,
        height: 34
    },
    default_option: {
        display: 'none'
    }
}))

const FieldSelect = ({
    label,
    name,
    register,
    list,
    defaultOption,
    disabled,
    isLabel = true
}) => {
    const classes = useStyles();

    return (
        <label htmlFor={name} className={classes.root} style={{marginTop: isLabel ? -12 : 0}}>
            {
                isLabel && <span className={classes.label}>{label}</span>
            }
            <select
                {...register(name)}
                className={classes.select}
                disabled={disabled}
            >
                <option value="" className={classes.default_option}>{defaultOption}</option>
                {
                    list.map((item) => (
                        <option value={item.value}>{item.label}</option>
                    ))
                }
            </select>
        </label>
    )
}

export default FieldSelect;